import React from "react";
import {
    Row,
} from "antd";
import ColorPicker from "../../Components/Common/ColorPicker";
import TextField from "../Common/TextField";
import { useSelector, useDispatch } from "react-redux";
import AssetUploader from "../Common/AssetUploader";
import {themeItemUpdated} from "../../store/actions/WebchatBrandingElementsAction";
import updateStyling from "utility/PortalPostMessage";

const defaultmainElementColor = '#000';
const defaultbuttonTextColor = "#000";
const defaultLinkTextColor = "#0000EE";


export default function WebchatBrandingTabMenuTheme() {
    const dispatch = useDispatch();
    const { previewState } = useSelector((state) => state.WebchatBrandingElementsReducer);

    const BRAND_MAIN_ELEMENT_COLOR_KEY = "mainElementColor";
    const BRAND_BUTTON_TEXT_COLOR_KEY = "buttonTextColor";
    const BRAND_LINK_TEXT_COLOR_KEY = "linkTextColor";
    const BRAND_TITLE_KEY = "pageTitle";
    const BRAND_HEADER_ICON_KEY = "headerIcon";
    const BRAND_FAV_ICON_KEY = "favicon";

    const onAssetUploadCallbackPageHeaderIcon = (uploadedAssetUrl) => {
        if (uploadedAssetUrl === undefined) {
            return;
        }
        updateStyling(document, BRAND_HEADER_ICON_KEY, uploadedAssetUrl)
        dispatch(themeItemUpdated(BRAND_HEADER_ICON_KEY, uploadedAssetUrl));
    }

    const onAssetUploadCallbackFavicon = (uploadedAssetUrl) => {
        if (uploadedAssetUrl === undefined) {
            return;
        }
        updateStyling(document, BRAND_FAV_ICON_KEY, uploadedAssetUrl)
        dispatch(themeItemUpdated(BRAND_FAV_ICON_KEY, uploadedAssetUrl));
    }

    return (
        <div className="ant-collapse-content-box">
            <p>The colors below are used across prominent buttons, switches, and menu icons.</p>

            <Row gutter={[10, 10]} style={{ marginLeft: 10 }}>
                <ColorPicker label="Main Element Color" initialValue={previewState[BRAND_MAIN_ELEMENT_COLOR_KEY] || defaultmainElementColor} onChange={(color) => {
                    updateStyling(document, BRAND_MAIN_ELEMENT_COLOR_KEY, color)
                    dispatch(themeItemUpdated(BRAND_MAIN_ELEMENT_COLOR_KEY,color))
                }} />
                <ColorPicker label="Button Text Color" initialValue={previewState[BRAND_BUTTON_TEXT_COLOR_KEY]|| defaultbuttonTextColor} onChange={(color) => {
                    updateStyling(document, BRAND_BUTTON_TEXT_COLOR_KEY, color)
                    dispatch(themeItemUpdated(BRAND_BUTTON_TEXT_COLOR_KEY,color))
                }} />
                <ColorPicker label="Link Text Color" initialValue={previewState[BRAND_LINK_TEXT_COLOR_KEY] || defaultLinkTextColor} onChange={(color) => {
                    updateStyling(document, BRAND_LINK_TEXT_COLOR_KEY, color)
                    dispatch(themeItemUpdated(BRAND_LINK_TEXT_COLOR_KEY,color))
                }} />
                <TextField
                    label="Page Title"
                    onChange={(value) => {
                        dispatch(themeItemUpdated(BRAND_TITLE_KEY,value))
                    }}
                    placeholder={previewState[BRAND_TITLE_KEY] || "ChatStream"}
                />
                <div style={{ marginTop: 20 }}>
                    <h3 style={{ marginBottom: 0, fontWeight: "bold" }}>Page Header Icon</h3>
                    <AssetUploader currentIconUrl={previewState[BRAND_HEADER_ICON_KEY]} onAssetUploadCallback={onAssetUploadCallbackPageHeaderIcon}/>
                </div>
                <div style={{ marginTop: 20 }}>
                    <h3 style={{ marginBottom: 0, fontWeight: "bold" }}>Favicon</h3>
                    <AssetUploader currentIconUrl={previewState[BRAND_FAV_ICON_KEY]} onAssetUploadCallback={onAssetUploadCallbackFavicon}/>
                </div>
            </Row>
        </div>
    );
}
